export default {
    adminUser: "AdminUser",
    addAdminUser: "AddAdminUser",
    editAdminUser: "EditAdminUser",
  };
  